export enum EditorType {
  Markdown = 'markdown',
  Draft = 'draft',
}

export enum MarkdownType {
  Edit = 'edit',
  Preview = 'preview',
  SideBySide = 'sidebyside',
}
